import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { PsychologySection } from './components/PsychologySection';
import { IndustrySection } from './components/IndustrySection';
import { ProductPresentation } from './components/ProductPresentation';
import { SocialProof } from './components/SocialProof';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { PaymentBadges } from './components/PaymentBadges';
import { Footer } from './components/Footer';
import { LivePurchaseNotification } from './components/LivePurchaseNotification';
export function App() {
  useEffect(() => {
    // Meta Pixel — Manual Injection Master Code LLOYD v10.0
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '796624063387305');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // <noscript> fallback pixel
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=796624063387305&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-dark text-white selection:bg-gold/30 selection:text-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PsychologySection data-id="element-4" />
        <IndustrySection data-id="element-5" />
        <ProductPresentation data-id="element-6" />
        <SocialProof data-id="element-7" />
        <ValueStack data-id="element-8" />
        <Guarantee data-id="element-9" />
        <PaymentBadges data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <LivePurchaseNotification data-id="element-12" />
    </div>;
}